export const primaryStations = [
    { name:'Central SAT Deslizamientos', id: 188},
    { name:'Central Caldas', id: 183},
    { name:'Central Nevados', id: 1},
    { name:'Central SAT Manizales', id: 186 },
    { name:'Central JDEGER', id: 187},
    { name:'Central Chec', id: 184},
    { name: 'CENICAFÉ', id: 37}
];

export const soundStations = [
    { name:'Gimnasio Campestre La Consolata', id: 173},
    { name:'Entrada a Solferino', id: 168},
    { name:'Familia Amador - Maltería', id: 176},
    { name:'Escuela de Carabineros', id: 195},
    { name:'Asunción - Confa', id: 196},
    { name:'Cisco - Bosques del Norte', id: 171},
    { name:'Montevideo', id: 192},
    { name:'La Manuela', id: 190},
    { name:'El Pescador', id: 199},
    { name: 'Santágueda', id: 205},
    { name: 'Rioclaro', id: 207},
    { name: 'El Destierro', id: 189},
    { name: 'Molinos', id: 200},
    { name: 'Cruz Roja - JDEGER', id: 198},
    { name: 'El Destierro', id: 189},
    { name: 'Repetidora Chipre', id: 191}
];

export const hideHydrologicalStations = [
    { name: 'RÍO TOTUÍ', id: 60},
    { name: 'Q. La Estrella', id: 65 },
    { name: 'Río Campoalegre - Ínsula', id: 66 },
    { name: 'Río Campoalegre - Tarapacá', id: 67 },
    { name: 'Río Chinchiná - Bocatoma Municipal', id: 69 },
    { name: 'Río Chinchiná - Bocatoma Montevideo', id: 68 },
    { name: 'Río Chinchiná - Jardines', id: 204},
    { name: 'Río Chinchiná - Bocatoma Sancancio', id: 70 },
    { name: 'Río Guacaica - Bocatoma', id: 71 },
    { name: 'Río San Francisco', id: 64 }
]
